module.exports = __webpack_public_path__ + "static/media/communication_icon.d5ff7918.svg";